<div class="custom-tooltip">
    <div>{{ params.value }}</div>
</div>